// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1V7DI","title":"Header_title__1m7dZ","side":"Header_side__2z9CM"};